if (!customElements.get('continuous-logo-loop')) {
  customElements.define('continuous-logo-loop', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-logo-loop-track]');
      this.sourceGroup = this.querySelector('[data-logo-loop-source]');

      if (!this.track || !this.sourceGroup || !this.sourceGroup.children.length) {
        return;
      }

      this.lastObservedWidth = Math.round(this.getBoundingClientRect().width);
      this.resizeObserver = new ResizeObserver((entries) => {
        const observedWidth = Math.round(entries[0].contentRect.width);

        if (!observedWidth || observedWidth === this.lastObservedWidth) {
          return;
        }

        this.lastObservedWidth = observedWidth;
        this.scheduleBuild();
      });
      this.resizeObserver.observe(this);
      this.scheduleBuild();
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
      cancelAnimationFrame(this.buildFrame);
    }

    scheduleBuild() {
      cancelAnimationFrame(this.buildFrame);
      this.buildFrame = requestAnimationFrame(() => this.build());
    }

    build() {
      this.track.querySelectorAll('[data-logo-loop-clone]').forEach((element) => element.remove());
      this.sourceGroup.querySelectorAll('[data-logo-loop-copy]').forEach((element) => element.remove());

      const originalItems = Array.from(this.sourceGroup.children);

      if (!originalItems.length) {
        return;
      }

      let copyIndex = 0;

      while (this.sourceGroup.scrollWidth < this.clientWidth + 1 && copyIndex < 100) {
        const copy = originalItems[copyIndex % originalItems.length].cloneNode(true);
        copy.setAttribute('data-logo-loop-copy', '');
        this.scrubEditorAttributes(copy);
        this.sourceGroup.append(copy);
        copyIndex += 1;
      }

      const clonedGroup = this.sourceGroup.cloneNode(true);
      clonedGroup.removeAttribute('data-logo-loop-source');
      clonedGroup.setAttribute('data-logo-loop-clone', '');
      clonedGroup.setAttribute('aria-hidden', 'true');
      this.scrubEditorAttributes(clonedGroup);
      clonedGroup.querySelectorAll('a, button, input, select, textarea').forEach((element) => {
        element.tabIndex = -1;
      });
      this.track.append(clonedGroup);

      const distance = this.sourceGroup.getBoundingClientRect().width;
      const speed = Math.max(Number(this.dataset.speed) || 50, 1);
      this.style.setProperty('--logo-loop-distance', `${distance}px`);
      this.style.setProperty('--logo-loop-translate', `${distance * -1}px`);
      this.style.setProperty('--logo-loop-duration', `${Math.max(distance / speed, 8)}s`);

      this.track.style.animation = 'none';
      this.track.offsetWidth;
      this.track.style.removeProperty('animation');
    }

    scrubEditorAttributes(element) {
      const elements = [element, ...element.querySelectorAll('*')];

      elements.forEach((child) => {
        child.removeAttribute('id');
        child.removeAttribute('data-shopify-editor-block');
      });
    }
  });
}
